import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getActivities = async (focusGroupId) => {
    const { data } = await vlqrApi.get(`focusGroups/${focusGroupId}/activities`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const useActivitiesForFocusGroup = (focusGroupId, options = {}) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['activitiesForFocusGroup', focusGroupId],
        queryFn: () => getActivities(focusGroupId),
        ...options
    });

    return { data, refetch, isLoading, isError };
};

export default useActivitiesForFocusGroup;
